import { siteClearance } from '@utils/clearanceHelpers'

export default [
  {
    path: '/mx/:store/hiring',
    component: () => import('@views/empty-router-view.vue'),
    children: [
      {
        // Rfc validator
        path: '',
        name: 'hiring-collaborator',
        component: () => import('@modules/collaborators/views/new-collaborator/new-collaborator.vue'),
        meta: {
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
          authorizeWithPermission: 'hiring',
        },
      },
      {
        // Add new collaborator
        path: 'newHiring',
        name: 'new-hiring',
        component: () => import('@modules/collaborators/views/new-hiring/new-hiring.vue'),
        meta: {
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
          authorizeWithPermission: 'hiring',
        },
      },
      {
        // Obtain data from collab
        path: 'getPersonalData/:collaboratorId',
        name: 'personal-data',
        component: () => import('@modules/collaborators/views/new-hiring/new-hiring.vue'),
        meta: {
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
          authorizeWithPermission: 'hiring',
        },
      },
      // Address view for new collaborator
      {
        path: 'address/:collaboratorId',
        name: 'hiring-address-data',
        component: () => import('@modules/collaborators/views/collaborator-address/address-data.vue'),
        meta: {
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
          authorizeWithPermission: 'hiring',
        },
      },
      {
        // Fiscal view for new collaborator
        path: 'fiscal/:collaboratorId',
        name: 'fiscal-data',
        component: () => import('@modules/collaborators/views/collaborator-fiscal/fiscal-data.vue'),
        meta: {
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
          authorizeWithPermission: 'hiring',
        },
      },
      {
        // Bank view for new collaborator
        path: 'bank/:collaboratorId',
        name: 'bank-data',
        component: () => import('@modules/collaborators/views/collaborator-bank/bank-data.vue'),
        meta: {
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
          authorizeWithPermission: 'hiring',
        },
      },
      {
        // Labor view for new collaborator
        path: 'labor/:collaboratorId',
        name: 'labor-data',
        component: () => import('@modules/collaborators/views/collaborator-labor/collaborator-labor.vue'),
        meta: {
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
          authorizeWithPermission: 'hiring',
        },
      },
      {
        path: 'contracts/:uuid/preview',
        name: 'contract-preview',
        component: () => import('@modules/collaborators/views/collaborator-contract/contract-preview.vue'),
        meta: {
          authRequired: true,
          authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
          authorizeWithPermission: 'hiring',
        },
      },
    ],
  },
  {
    // Process for new collaborator
    path: '/mx/:store/general/openProcesses/:collaboratorId',
    name: 'process-data',
    component: () => import('@modules/collaborators/views/collaborator-process/process-data.vue'),
    meta: {
      authRequired: true,
      authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
      authorizeWithPermission: 'hiring',
    },
  },
  {
    path: '/mx/:store/openProcesses',
    name: 'open-processes-store',
    component: () => import('@modules/collaborators/views/open-processes/open-processes.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/mx/openProcesses',
    name: 'open-processes',
    component: () => import('@modules/collaborators/views/open-processes/open-processes.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/mx/:store/mutationProcess',
    name: 'mutation-processes',
    component: () => import('@/modules/collaborators/views/mutation-process/mutation-process-list.vue'),
    meta: {
      authRequired: true,
      authorize: [...siteClearance.admin, ...siteClearance.director],
    },
  },
  {
    path: '/mx/:store/collaborators',
    name: 'collaborator-list',
    component: () => import('@modules/collaborators/views/collaborator-list/collaborator-list-site.vue'),
    meta: {
      authRequired: true,
      authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
    },
  },
  {
    path: '/mx/:store/collaborators/:collaboratorId',
    name: 'collaborator-summary',
    component: () => import('@modules/collaborators/views/collaborator-info/collaborator-info.vue'),
    meta: {
      authRequired: true,
      authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
      authorizeWithPermission: 'hiring',
    },
  },
  {
    path: '/mx/:store/collaborators/:collaboratorId/mutation',
    name: 'collaborator-mutation-start',
    component: () => import('@/modules/collaborators/views/collaborator-mutation/collaborator-mutation-start.vue'),
    meta: {
      authRequired: true,
      authorize: [...siteClearance.admin, ...siteClearance.director],
    },
  },
  {
    path: '/mx/:store/collaborators/:collaboratorId/leave',
    name: 'collaborator-leave',
    component: () => import('@/modules/collaborators/views/collaborator-leave/collaborator-leave.vue'),
    meta: {
      authRequired: true,
      authorize: [...siteClearance.admin, ...siteClearance.director, ...siteClearance.responsible, ...siteClearance.responsibleOperation],
    },
  },
  {
    path: '/mx/:store/leaveProcesses',
    name: 'leave-processes',
    component: () => import('@modules/collaborators/views/leave-processes/leave-processes.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/mx/:store/collaborators/terminated',
    name: 'terminated-collaborators',

    component: () => import('@modules/collaborators/views/collaborator-terminated/terminated-collaborators.vue'),
    meta: {
      authRequired: true,
      authorize: [...siteClearance.admin],
    },
  },
]
